import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import TickSection from "../../components/tickSection/TickSection";
import './aboutPage.css';
import AllySkiing1 from '../../assets/ally-skiing-1.png';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import BigButton from "../../components/bigButton/BigButton";



const AboutPage = () => {
    const navigate = useNavigate();

    const handleGoToPortfolioPage = (): void => {
        navigate("/portfolio");
    };
    return (
        <div>
            <Helmet>
                <title>Om Alpine Sport – Din personliga skidtekniker i Kristinehamn, Värmland</title>
                <meta
                    name="description"
                    content="Alpine Sport i Värmland är en liten, passionerad skidverkstad i Kristinehamn. Vi erbjuder professionell service, reparationer och personlig rådgivning för att förbättra din skidupplevelse."
                />
                <meta property="og:title" content="Om Alpine Sport – Din Skidservice i Värmland" />
                <meta
                    property="og:description"
                    content="Alpine Sport i Värmland är en liten, passionerad skidverkstad i Kristinehamn. Vi erbjuder professionell service, reparationer och personlig rådgivning för att förbättra din skidupplevelse."
                />
                <meta property="og:image" content="%PUBLIC_URL%/socials-image.png" />
                <link rel="icon" href="%PUBLIC_URL%/colours-favicon.png" type="image/png" />
                <meta property="og:url" content="https://alpinesport.se/om" />
                <meta property="og:type" content="website" />
                <link rel="canonical" href="https://alpinesport.se/om" />
            </Helmet>
            <Header />
            <main>
                <TickSection />
                <section className="aboutPage-container">
                    <section>
                        <img
                            className="about-img"
                            src={AllySkiing1}
                            alt="owner skiing" />
                    </section>
                    <section className="about-textContainer">
                        <h2>
                            HEJ!
                        </h2>
                        <article>
                            <p className="about-p">
                                Alpine Sport i Värmland är en liten verksamhet som jag bedriver hemifrån med målet att alla ska ha en roligare dag i backen. Alla har upplevt att ibland så funkar det bara inte att åka skidor i vissa förhållanden. Det kan vara snö som sitter fast under skidan, tröga skidor, slöa kanter som inte biter när det är hårt i backen eller om man har otur kan man med felinställd utrustning orsaka onödiga skador på dig själv. Det blir tråkigt om man får skidsemestern förstörd av enkla saker som kan fixas i förväg. <br /><br />
                                Jag som driver Alpine Sport i Värmland heter Alistair McCann. Jag sitter på över 40års erfarenhet av skidåkning och fjällerfarenhet som ger mig en gedigen grund att utgå ifrån. Kan en skotte verkligen åka skidor hör jag er fråga? Jo då, säger jag! Man brukar säga ’kan man åka skidor i Skottland, så kan man åk skidor vart som helst!’. Det är för att man får allt i ett åk, puder, is, sten, gräs, slask och skare. Där fick man vara på tårna hela tiden och det var verkligen inte att bara åka! <br /><br />
                                Min utrustning har jag alltid servat och reparerat själv och jag insåg tidigt hur små skillnader och justeringar kan ge mycket positiva effekter för skidåkningen. Jag som har åkt mycket känner av hur en liten tejp bit eller justering kan göra världens skillnad. Det kanske låter lite skidnördigt men jag vill påstå att nybörjaren, även om de inte direkt känner av små justeringar, kan omedvetet få ut mer av sin skidåkning då det blir både enklare och roligare. <br /><br />
                                Jag är inte bara självlärd jag är också utbildad till avancerad skidtekniker och bootfitter. Det betyder att du får den bästa servicen av någon som verkligen bryr sig och alltid med flourfri valla! <br /><br />
                                Välkommen hem till Alpine Sport i Kristinehamn med din utrustning för service och reparationer! Om du istället är i behov av råd när det gäller utrustning och pjäxor så gör jag allt jag kan att hjälpa! <br /><br />
                                Vi syns i backen!
                            </p>
                            <p className="signature">
                                Alistair McCann
                            </p>
                        </article>
                        <section>
                            <article>
                                <p className="about-p">
                                    PS. <br />
                                    I&apos;m not just a skilled alpine ski technician, I&apos;m much more than that! I&apos;m a qualified frontend developer with skills in UX design and SEO. With these combined skillsets I have a strong understanding of how to create designs that easily convert to sympantic code that mets the product owners and their customers needs. Check out my portfolio page to find out more about my projects and personal style:
                                </p>
                                <BigButton
                                    text="Visit my Portfolio"
                                    onClick={handleGoToPortfolioPage}
                                    className="portfolio-btn"
                                />
                            </article>
                        </section>
                    </section>
                    
                </section>

                <section className="aboutPage-container-mobile">
                    <section className="about-textContainer">
                        <h2>
                            HEJ!
                        </h2>
                        <img
                            className="about-img"
                            src={AllySkiing1}
                            alt="owner skiing" />
                        <article>
                            <p className="about-p">
                                Alpine Sport i Värmland är en liten verksamhet som jag bedriver hemifrån med målet att alla ska ha en roligare dag i backen. Alla har upplevt att ibland så funkar det bara inte att åka skidor i vissa förhållanden. Det kan vara snö som sitter fast under skidan, tröga skidor, slöa kanter som inte biter när det är hårt i backen eller om man har otur kan man med felinställd utrustning orsaka onödiga skador till dig själv. Det blir tråkigt om man får skidsemestern förstörd av enkla saker som kan fixas i förväg. <br /><br />
                                Jag som driver Alpine Sport i Värmland heter Alistair McCann. Jag sitter på över 40års erfarenhet av skidåkning och fjällerfarenhet som ger mig en gedigen grund att utgå ifrån. Kan en skotte verkligen åka skidor hör jag er fråga? Jo då, säger jag! Man brukar säga ’kan man åka skidor i Skottland, så kan man åk skidor vart som helst!’. Det är för att man får allt i ett åk, puder, is, sten, gräs, slask och skare. Där fick man vara på tårna hela tiden och det var verkligen inte att bara åka! <br /><br />
                                Min utrustning har alltid servat och reparerat och jag insåg tidigt hur små skillnader och justeringar kan ge mycket positiva effekter för skidåkningen. Jag som har åkt mycket känner av hur en liten tejp bit eller justering kan göra världens skillnad. Men nu måste jag berätta att jag är en riktig skidnörd men jag vill påstå att nybörjaren, även om de inte direkt känner av små justeringar, kan omedvetet få ut mer av sin skidåkning då det blir både enklare och roligare. <br /><br />
                                Jag är inte bara självlärd jag är också utbildad till avancerad skidtekniker och bootfitter. Det betyder att du får den bästa servicen av någon som verkligen bryr sig och alltid med flourfri valla! <br /><br />
                                Välkommen med din utrustning till Alpine Sport for service och reparationer! Om du istället är i behov av råd när det gäller utrustning och pjäxor så gör jag allt jag kan att hjälpa! <br /><br />
                                Vi syns i backen!
                            </p>
                            <p className="signature">
                                Alistair McCann
                            </p>
                        </article>
                        <section>
                            <article>
                                <p className="about-p">
                                    PS. <br /><br />
                                    I&apos;m not just a skilled alpine ski technician, I&apos;m much more than that! I&apos;m a qualified frontend developer with skills in UX design and SEO. With these combined skillsets I have a strong understanding of how to create designs that easily convert to sympantic code that mets the product owners and their customers needs. Check out my portfolio page to find out more about my projects and personal style:
                                </p>
                                <BigButton
                                    text="Visit my Portfolio"
                                    onClick={handleGoToPortfolioPage}
                                    className="portfolio-btn"
                                />
                            </article>
                        </section>
                    </section>
                </section>

            </main>
            <Footer />
        </div>
    );
}

export default AboutPage;